import { render, staticRenderFns } from "./WarrantyRegistration.vue?vue&type=template&id=4125851e&scoped=true"
import script from "./WarrantyRegistration.vue?vue&type=script&lang=js"
export * from "./WarrantyRegistration.vue?vue&type=script&lang=js"
import style0 from "./WarrantyRegistration.vue?vue&type=style&index=0&id=4125851e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4125851e",
  null
  
)

export default component.exports